/**
 * Created by Administrador on 30/06/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('permissions', {
                parent: 'app',
                url: '/permissions',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/permission/permissions.html',
                        controller: 'permissionsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['permission']);
                    }],
                    permissions: ['userService', function(userService){
                        return userService.getPermissions()
                    }]
                }
            });
    }
})();
